
































import Vue, { PropType } from 'vue'
import { BModal } from 'bootstrap-vue'

export default Vue.extend({
  name: 'CpModal',
  components: {
    BModal,
  },
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
    },

    scrollable: {
      type: Boolean,
      default: false,
    },
    modalClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<'md' | 'xl'>,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    NoCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    NoCloseOnEsc: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      ;(this.$refs.modal as any).show()
    },
    hide() {
      ;(this.$refs.modal as any).hide()
    },
    toggle() {
      ;(this.$refs.modal as any).toggle()
    },
    close() {
      ;(this.$refs.modal as any).onClose()
    },
    onChange(visible: boolean) {
      this.$emit('change', visible)
    },
  },
})
